import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { orgIdWithRelKey } from "common";

interface OrgIdWithRelState {
  orgIdWithRel: string;
}

const initialState: OrgIdWithRelState = {
  orgIdWithRel: localStorage.getItem(orgIdWithRelKey) ?? "",
};

export const orgIdWithRelSlice = createSlice({
  name: "orgIdWithRelRTK",
  initialState,
  reducers: {
    setOrgIdWithRelRTK: (state, action: PayloadAction<OrgIdWithRelState>) => {
      state.orgIdWithRel = action.payload.orgIdWithRel;
      localStorage.setItem(orgIdWithRelKey, action.payload.orgIdWithRel);
    },
    clearOrgIdWithRelRTK: (state) => {
      state.orgIdWithRel = "";
      localStorage.removeItem(orgIdWithRelKey);
    },
  },
});

export const { setOrgIdWithRelRTK, clearOrgIdWithRelRTK } =
  orgIdWithRelSlice.actions;
export default orgIdWithRelSlice.reducer;
